import { Link, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Wordmark } from "../components/Brand";
import { Home, LogOut, Lock } from "lucide-react";

export default function SectionLayout({ title, description }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-canvas" data-testid="section-layout">
      <header className="bg-navy text-white px-6 sm:px-10 py-4 flex items-center justify-between sticky top-0 z-10" data-testid="section-header">
        <div className="flex items-center gap-4">
          <Wordmark light size="text-lg" />
          <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-white/50 hidden sm:flex items-center gap-1">
            <Lock size={10} /> Operations Hub</span>
        </div>
        <div className="flex items-center gap-2">
          <Link to="/" className="flex items-center gap-1.5 text-sm font-bold text-white/70 hover:text-white transition-colors px-3 py-1.5"
            data-testid="hub-home-link">
            <Home size={15} /> Hub Home
          </Link>
          <span className="text-sm text-white/60 hidden md:inline" data-testid="section-user-name">{user?.name}</span>
          <button className="text-white/60 hover:text-white transition-colors p-1.5" title="Sign out" data-testid="section-logout-button"
            onClick={async () => { await logout(); navigate("/login"); }}>
            <LogOut size={16} />
          </button>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-6 sm:px-10 py-8">
        <Outlet />
      </main>
    </div>
  );
}
